import { render, staticRenderFns } from "./basicconfig.vue?vue&type=template&id=3eec46ef"
import script from "./basicconfig.vue?vue&type=script&lang=js"
export * from "./basicconfig.vue?vue&type=script&lang=js"
import style0 from "./basicconfig.vue?vue&type=style&index=0&id=3eec46ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports